<template>
  <div
    class="d-flex justify-content-center align-items-center rounded-circle step mr-2"
    :class="active ? 'active' : ''"
  >
    <small class="text-bold mb-0">{{ number }}</small>
  </div>
</template>

<script>
export default {
  name: "NumberedStep",
  props: {
    number: Number,
    active: Boolean,
  },
};
</script>

<style scoped lang="scss">
.step {
  border: 1px solid $color-orange;
  color: $color-orange;
  width: 24px;
  height: 24px;
  padding: 1px 0 0 1px;

  &.active {
    color: $color-white;
    background-color: $color-orange;
  }
}
</style>
